<template>
  <div class="list-table" v-if="!isMobile">
    <div class="sticky">
      <table>
        <thead>
          <th class='status'>
            <input type="checkbox" v-model="selectAll" :disabled="loading" />
          </th>
          <th>Vehicle #</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'businessName'}"
            @click="sort('businessName')">
            {{ $t('provider.list.table.businessName') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'businessName'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'licenseType'}"
            @click="sort('licenseType')">
            {{ $t('provider.list.table.type') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'licenseType'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'accountStatus'}"
            @click="sort('accountStatus')">
            {{ $t('provider.list.table.status') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'accountStatus'"></i>
          </th>
          <th>Service</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'vehicleType'}"
            @click="sort('vehicleType')">
            {{ $t('provider.list.table.vehicle') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'vehicleType'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'wheelchair'}"
            @click="sort('wheelchair')">
            ADA
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'wheelchair'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'city'}"
            @click="sort('city')">
            {{ $t('provider.list.table.city') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'city'"></i>
          </th>
          <th>{{ $t('provider.list.table.phone') }}</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'created'}"
            @click="sort('created')">
            Created Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'created'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'lastUpdate'}"
            @click="sort('lastUpdate')">
            {{ $t('provider.list.table.lastUpdate') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'lastUpdate'"></i>
          </th>
          <!-- <th>{{ $t('provider.list.table.license') }}</th>
          <th>{{ $t('provider.list.table.insurance') }}</th>
          <th>{{ $t('provider.list.table.permit') }}</th>
          <th>{{ $t('provider.list.table.cityLicense') }}</th>
          <th>{{ $t('provider.list.table.airport') }}</th>
          <th>{{ $t('provider.list.table.safetyInspect') }}</th> -->
          <th :class="{'sortable':true, 'active':currentOrder.field === 'lastLogin'}"
            @click="sort('lastLogin')">
            Last On Duty
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'lastLogin'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'bgCheck'}"
            @click="sort('bgCheck')">
            {{ $t('provider.list.table.bgCheck') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'bgCheck'"></i>
          </th>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td class='status'><input type="checkbox" v-model="selected" :value="user.id" number :disabled="loading" /></td>
            <td><a :href="'/#/provider/' + user.id" target="_blank">{{ user.driverNum }}</a></td>
            <td><a :href="'/#/provider/' + user.id" target="_blank">{{ user.business }}</a></td>
            <td><span :class="['type', user.type]">{{ user.type }}</span></td>
            <td class="status"><span :class="['stat-ico', user.status]"></span>{{ statusLabel(user.status) }}</td>
            <td class="status">{{ user.service }}</td>
            <td class="status">{{ user.vehicleType }}</td>
            <td class="">{{ user.wheelChairLift ? 'YES' : 'NO' }}</td>
            <td class="city">{{ user.city }}</td>
            <td class="phone">{{ user.phone }}</td>
            <td>{{ user.created }}</td>
            <td>{{ user.lastUpdate }}</td>
            <!-- <td :class="expired(user.license)">{{ user.license }}</td>
            <td :class="expired(user.insurance)">{{ user.insurance }}</td>
            <td :class="expired(user.permit)">{{ user.permit }}</td>
            <td :class="expired(user.cityLicense)">{{ user.cityLicense }}</td>
            <td :class="expired(user.airport)">{{ user.airport }}</td>
            <td :class="expired(user.safetyInspect)">{{ user.safetyInspect }}</td> -->
            <td class="date">{{ user.lastLogin }}</td>
            <td>
              <i class="fas fa-check-circle fa-2x" v-if="user.bgCheckPassed && target == 'tnc'"></i>
              <i v-else-if="user.bgCheckSubmitted && target == 'tnc'">Submitted</i>
              <span class="empty" v-else-if="!user.bgCheckPassed && !user.bgCheckSubmitted && target == 'tnc'"></span>
              <i class="fas fa-check-circle fa-2x" v-else-if="user.bgCheck && target != 'tnc'"></i>
              <i class="fas fa-times-circle fa-2x" v-else></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-table">
      <table class="main-table">
        <thead>
          <th class='status'>
            <input type="checkbox" v-model="selectAll" :disabled="loading" />
          </th>
          <th>Vehicle #</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'businessName'}"
            @click="sort('businessName')">
            {{ $t('provider.list.table.businessName') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'businessName'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'licenseType'}"
            @click="sort('licenseType')">
            {{ $t('provider.list.table.type') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'licenseType'"></i>
          </th>
          <!-- <th>{{ $t('provider.list.table.type') }}</th> -->
          <th :class="{'sortable':true, 'active':currentOrder.field === 'accountStatus'}"
            @click="sort('accountStatus')">
            {{ $t('provider.list.table.status') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'accountStatus'"></i>
          </th>
          <th>Service</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'vehicleType'}"
            @click="sort('vehicleType')">
            {{ $t('provider.list.table.vehicle') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'vehicleType'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'wheelchair'}"
            @click="sort('wheelchair')">
            {{ $t('provider.list.table.vehicle') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'wheelchair'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'city'}"
            @click="sort('city')">
            {{ $t('provider.list.table.city') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'city'"></i>
          </th>
          <th>{{ $t('provider.list.table.phone') }}</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'created'}"
            @click="sort('created')">
            Created Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'created'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'lastUpdate'}"
            @click="sort('lastUpdate')">
            {{ $t('provider.list.table.lastUpdate') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'lastUpdate'"></i>
          </th>
          <!-- <th>{{ $t('provider.list.table.license') }}</th>
          <th>{{ $t('provider.list.table.insurance') }}</th>
          <th>{{ $t('provider.list.table.permit') }}</th>
          <th>{{ $t('provider.list.table.cityLicense') }}</th>
          <th>{{ $t('provider.list.table.airport') }}</th>
          <th>{{ $t('provider.list.table.safetyInspect') }}</th> -->
          <th :class="{'sortable':true, 'active':currentOrder.field === 'lastLogin'}"
            @click="sort('lastLogin')">
            Last On Duty
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'lastLogin'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'bgCheck'}"
            @click="sort('bgCheck')">
            {{ $t('provider.list.table.bgCheck') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'bgCheck'"></i>
          </th>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td class='status'>
              <input type="checkbox" v-model="selected" :value="user.id" number :disabled="loading" />
            </td>
            <td><a :href="'/#/provider/' + user.id" target="_blank">{{ user.driverNum }}</a></td>
            <td>
              <a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.business }}</a>
            </td>
            <td><span :class="['type', user.type]">{{ user.type }}</span></td>
            <td class="status"><span :class="['stat-ico', user.status]"></span>{{ statusLabel(user.status) }}</td>
            <td class="status">{{ user.service }}</td>
            <td class="status">{{ user.vehicleType }}</td>
            <td class="">{{ user.wheelChairLift ? 'YES' : 'No' }}</td>
            <td class="city">{{ user.city }}</td>
            <td class="phone">{{ user.phone }}</td>
            <td>{{ user.created }}</td>
            <td>{{ user.lastUpdate }}</td>
            <!-- <td :class="expired(user.license)">{{ user.license }}</td>
            <td :class="expired(user.insurance)">{{ user.insurance }}</td>
            <td :class="expired(user.permit)">{{ user.permit }}</td>
            <td :class="expired(user.cityLicense)">{{ user.cityLicense }}</td>
            <td :class="expired(user.airport)">{{ user.airport }}</td>
            <td :class="expired(user.safetyInspect)">{{ user.safetyInspect }}</td> -->
            <td class="date">{{ user.lastLogin }}</td>
            <td>
              <i class="fas fa-check-circle fa-2x" v-if="user.bgCheckPassed && target == 'tnc'"></i>
              <i v-else-if="user.bgCheckSubmitted && target == 'tnc'">Submitted</i>
              <span class="empty" v-else-if="!user.bgCheckPassed && !user.bgCheckSubmitted && target == 'tnc'"></span>
              <i class="fas fa-check-circle fa-2x" v-else-if="user.bgCheck && target != 'tnc'"></i>
              <i class="fas fa-times-circle fa-2x" v-else></i>
            </td>
          </tr>

          <tr v-show="loading && users.length === 0">
            <td colspan="13" class="table-block">
              <transition name="slide-up">
                <div v-show="loading" class="loader">
                  <i class="fas fa-spinner fa-spin"></i>
                  {{ $t('consumer.list.gettingUsers') }}
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="users.length === 0 && !loading">
            <td colspan="13" class="table-block">
              <transition name="slide-up">
                <div v-show="users.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!
                </div>
              </transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="users.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div v-show="loading && users.length === 0">
      <transition name="slide-up">
        <div v-show="loading" class="loader">
          <i class="fas fa-spinner fa-spin"></i>
          {{ $t('consumer.list.gettingUsers') }}
        </div>
      </transition>
    </div>

    <div v-show="users.length === 0 && !loading">
      <transition name="slide-up">
        <div v-show="users.length === 0 && !loading" class="empty-result">
          <i class="far fa-frown-open fa-3x"></i><br/>
          No record found!
        </div>
      </transition>
    </div>

    <div class="cards" v-for="user in users" :key="user.id">
      <div class="card">
        <div class="card-header">
          <div class="left">
            <input type="checkbox" v-model="selected" :value="user.id" number :disabled="loading" />
            <span :class="['type', user.type]">{{ user.type }}</span>
            <div :class="['status', user.status]">{{user.status}}</div>
          </div>
          <div class="right">
            <span v-if="user.bgCheckPassed && target == 'tnc' || user.bgCheck && target != 'tnc'">BG CHECK</span>
            <div>
              <i class="fas fa-check-circle fa-2x" v-if="user.bgCheckPassed && target == 'tnc'"></i>
              <i v-else-if="user.bgCheckSubmitted && target == 'tnc'">Submitted</i>
              <span class="empty" v-else-if="!user.bgCheckPassed && !user.bgCheckSubmitted && target == 'tnc'"></span>
              <i class="fas fa-check-circle fa-2x" v-else-if="user.bgCheck && target != 'tnc'"></i>
              <i class="fas fa-times-circle fa-2x" v-else></i>
            </div>
          </div>
        </div>
        <div class="title">
          <span class="label"><i class="fas fa-address-card"></i></span>
          <div class="value"><span v-show="user.driverNum"><a :href="'/#/provider/' + user.id" target="_blank">#{{ user.driverNum }}</a></span> <a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.business }}</a></div>
        </div>
        <div class="title" v-if="user.service">
          <span class="label">Service:</span>
          <div class="value">{{user.service}}</div>
        </div>
        <div class="title" v-if="user.vehicleType">
          <span class="label">Vehicle Type:</span>
          <div class="value">{{user.vehicleType}}</div>
        </div>
        <div class="title" v-if="user.city">
          <span class="label">City:</span>
          <div class="value">{{user.city}}</div>
        </div>
        <div class="title" v-if="user.phone">
          <span class="label">Phone:</span>
          <div class="value">{{user.phone}}</div>
        </div>
        <div class="title">
          <span class="label">ADA:</span>
          <div class="value">{{user.wheelChairLift ? 'YES' : 'NO'}}</div>
        </div>
        <div class="title" v-if="user.created">
          <span class="label">Date Created:</span>
          <div class="value">{{user.created}}</div>
        </div>
        <div class="title" v-if="user.lastUpdate">
          <span class="label">Last Update:</span>
          <div class="value">{{user.lastUpdate}}</div>
        </div>
        <div class="title" v-if="user.lastLogin">
          <span class="label">Last Login:</span>
          <div class="value">{{user.lastLogin}}</div>
        </div>
        
      </div>
    </div>
    <div class="fix-footer" v-show="!loading && users.length != 0">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiProviderList from '@/modules/api/provider/list'

export default {
  name: 'list-table',
  props: ['target'],
  data () {
    return {
      selected: [],
      isMobile: false
    }
  },
  computed: {
    users () { return this.$store.state.provider.users[this.target].list },
    selectAll: {
      get: function () { return this.selected.length === this.users.length && this.selected.length > 0 },
      set: function (value) {
        var selected = []
        if (value) {
          this.users.forEach(function (user) {
            selected.push(user.id)
          })
        }
        this.selected = selected
        this.$store.commit('provider/setUserSelected', {
          target: this.target,
          value: selected
        })
      }
    },
    loading () { return this.$store.state.provider.users[this.target].loading },
    currentOrder () {
      let prov = this.$store.state.provider.users[this.target]
      return { field: prov.order, asc: prov.orderAsc }
    },
    statusTable: {
      get: function () { return this.$store.state.provider.users.status },
      set: function (value) {
        this.$store.commit('provider/setUserStatus', value)
        this.refreshTable()
      }
    },
    serviceFilter () { return this.$store.state.provider.users.serviceFilter },
    perPage: {
      get: function () { return this.$store.state.provider.users[this.target].perPage },
      set: function (value) {
        this.$store.commit('provider/setUserPerPage', {
          target: this.target,
          value: parseInt(value)
        })
        this.$store.commit('provider/setUserCurrentPage', {
          target: this.target,
          value: 1
        })
        this.getList()
      }
    },
    pageData () {
      let tableData = this.$store.state.provider.users[this.target]
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.provider.users[this.target].currentPage },
      set: function (value) {
        this.$store.commit('provider/setUserCurrentPage', {
          target: this.target,
          value: parseInt(value)
        })
        this.getList()
      }
    },
    isLastPage () {
      let prov = this.$store.state.provider.users[this.target]
      return (prov.currentPage * prov.perPage) >= prov.maxList
    },
    totalPage () {
      let prov = this.$store.state.provider.users[this.target]
      return Math.ceil(prov.maxList / prov.perPage)
    }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('provider/resetUsers', self.target)
      self.$store.commit('provider/setUserIsLoading', {
        target: self.target,
        value: true
      })
      ApiProviderList.getList2(self, self.createParams(this.target), res => {
        self.$store.commit('provider/setUserIsLoading', {
          target: self.target,
          value: false
        })
      })
    },
    createParams (target) {
      let params = {
        target: target,
        status: this.statusTable,
        type: target
      }
      if (this.serviceFilter === 'PAX') {
        params.isPax = 1
        params.isDTD = 0
      }
      if (this.serviceFilter === 'DTD') {
        params.isPax = 0
        params.isDTD = 1
      }
      if (this.serviceFilter === 'PAX/DTD') {
        params.isPax = 1
        params.isDTD = 1
      }
      return params
    },
    sort (field) {
      if (this.loading) { return }
      let prov = this.$store.state.provider.users[this.target]
      if (field !== prov.order) {
        this.$store.commit('provider/setUserOrderAsc', {
          target: this.target,
          value: 1
        })
      } else {
        this.$store.commit('provider/setUserOrderAsc', {
          target: this.target,
          value: prov.orderAsc === 1 ? 0 : 1
        })
      }
      this.$store.commit('provider/setUserOrder', {
        target: this.target,
        value: field
      })
      this.$store.commit('provider/setUserCurrentPage', {
          target: this.target,
          value: 1
        })
      this.getList()
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('provider/setUserCurrentPage', {
        target: this.target,
        value: this.$store.state.provider.users[this.target].currentPage - 1
      })
      this.getList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('provider/setUserCurrentPage', {
        target: this.target,
        value: this.$store.state.provider.users[this.target].currentPage + 1
      })
      this.getList()
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    statusLabel (x) {
      if (x === 'onduty') return 'On Duty'
      else return 'Off Duty'
    }
  },
  mounted () {
    this.setScreenSize()
  },
  watch: {
    loading (value) { this.selected = [] },
    selected (value) {
      this.$store.commit('provider/setUserSelected', {
        target: this.target,
        value: value
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.list-table{
  border: 1px solid #aaa;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
  position: relative;
  min-height: 100px;
  overflow: hidden;
}

.sticky{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 44px;
  z-index: 3;

  tbody{ visibility: hidden; }
}

.scroll-table{
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .status{ text-transform: capitalize; }
  .city, .phone{}
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}

.fix-footer{
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.stat-ico{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dd2222;
  margin-right: 5px;
  vertical-align: -1px;

  &.onduty{ background: #22d728; }
}

@media only screen and (max-width: 430px) {
  .loader, .empty-result {
    text-align: center;
    padding: 30px;
  }
  .small-3 {
    width: 50%;
  }
  .fix-footer {
    select {
      max-width: 40px;
    }
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-size: 11px;

      > div {
        margin-bottom: 1px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left, .right {
          display: flex;
          align-items: center;
          gap: 10px;
          text-transform: uppercase;

          a {
            font-weight: 900;
          }
        
          .type{
            display: inline-block;
            padding: 3px 6px;
            text-transform: uppercase;
            border-radius: 4px;
            color: #fff;
            font-size: 11px;
            font-weight: 600;

            &.tnc{ background: #2ab77c; }
            &.tcp{ background: #3f81a0; }
            &.psc{ background: #de6c2a; }
          }

          .status {
            font-weight: 900;
            &.deactivated { color: #de2929; }
            &.active { color: #2ab77c; }
            &.pending { color: #de6c2a; }
            &.inactive { color: #bbb; }
          }
        }

        .right {
          gap: 5px;
          span {
            color: #999;
          }
        }
        input {
          display: inline-block;
          width: auto;
          margin: 0;
        }
        .expired{ color: #de2929; }
        .fa-check-circle{ color: #0fda4e; }
        .fa-times-circle{ color: #ef3535; }
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Provider/ListTable.vue